import { 
    ANGER,
    FEAR,
    SADNESS,
    JOY
} from '../../home/redux/constants';

export const SEE_MORE = "See More";
export const SEE_LESS = "See Less";
export const ELLIPSES = "...";

export const EMOTION_AND_INTENSITY_LABEL = "Emotion and Intensity";
export const HEATED_COMMENTS_PERCENTAGE_LABEL = "Percentage of Heated Comments";
export const NON_FACTUAL_LABEL = "Non-Factual";
export const HATEFUL_LABEL = "Hateful";
export const TOXIC_COMMENTS_PERCENTAGE_LABEL = "Percentage of Toxic Comments";
export const HEATED_COMMENT_LABEL = "Heated Comment";
export const TOXIC_COMMENT_LABEL = "Toxic Comment";
export const PERCENTAGE_LABEL = "%";
export const TOXICITY_SCORE_THRESHOLD = 0.5;

export const CHARGED_POST_ICON_FILE_PATH    = "/images/icons/feed_modal/charged_posts.svg";
export const HEATED_COMMENTS_ICON_FILE_PATH = "/images/icons/feed_modal/heated_comments.svg";
export const TOXIC_COMMENTS_ICON_FILE_PATH  = "/images/icons/feed_modal/toxic_comments.svg";
export const CONTROVERSY_INDICES_TO_ICONS_MAP = {
    [EMOTION_AND_INTENSITY_LABEL]:      CHARGED_POST_ICON_FILE_PATH,
    [HEATED_COMMENTS_PERCENTAGE_LABEL]: HEATED_COMMENTS_ICON_FILE_PATH,
    [NON_FACTUAL_LABEL]:                "/images/icons/feed_modal/non_factual_index.svg",
    [HATEFUL_LABEL]:                    "/images/icons/feed_modal/hateful_index.svg",
    [TOXIC_COMMENTS_PERCENTAGE_LABEL]:  TOXIC_COMMENTS_ICON_FILE_PATH
};

export const NONE_FEED_EMOTION_CATEGORY = "None";
export const EMOTION_TO_EMOTION_SCORE_MAP = {
    [ANGER]:   "anger_score",
    [FEAR]:    "fear_score",
    [SADNESS]: "sadness_score",
    [JOY]:     "joy_score"
}


// WEBPACK FOOTER //
// ./src/features/harmwatch/components/constants.js